import { Size } from 'src/app/shared/components/pointer/pointer.component';
import { Scenes } from 'src/app/rendering-3d/models/scenes.enum';

export const floorPlanPointers = [
    {
        yaw: -29.2 * Math.PI / 180, // x asix degrees
        pitch: -2.4 * Math.PI / 180, // y asix degrees
        size: Size.Plan,
        next: Scenes.Scene1,
        name: 'Scene1'
    },
    {
        yaw: -0.7 * Math.PI / 180, // x asix degrees
        pitch: -3.4 * Math.PI / 180, // y asix degrees
        size: Size.Plan,
        next: Scenes.Scene2,
        name: 'Scene2'
    },
    {
        yaw: 8.1 * Math.PI / 180, // x asix degrees
        pitch: 2.7 * Math.PI / 180, // y asix degrees
        size: Size.Plan,
        next: Scenes.Scene3,
        name: 'Scene3'
    },
    {
        yaw: 28.6 * Math.PI / 180, // x asix degrees
        pitch: -2.2 * Math.PI / 180, // y asix degrees
        size: Size.Plan,
        next: Scenes.Scene4,
        name: 'Scene4'
    },
];
